const { darken, lighten } = require("polished");

// Used so hover colors get automatically updated
const brandPrimaryColor = "#005891"; // blue
const brandSecondaryColor = "#ee7531"; // orange
const brandTertiaryColor = "#6ebd8f"; // green
const brandQuaternaryColor = "#ef7a91"; // pink
const brandQuinaryColor = "#fcbf33"; // yellow

const brandBlackColor = "#222222";
const brandGreyColor = "#CCCCCC";
const brandWhiteColor = "#FFFFFF";

const colors = {
    // Base colors
    "brand-primary": brandPrimaryColor,
    "brand-secondary": brandSecondaryColor,
    "brand-tertiary": brandTertiaryColor,
    "brand-quaternary": brandQuaternaryColor,
    "brand-quinary": brandQuinaryColor,

    // Base
    "brand-black": brandBlackColor,
    "brand-dark-grey": "#666666",
    "brand-grey": brandGreyColor,
    "brand-light-grey": "#F5F3EF",
    "brand-white": brandWhiteColor,

    // Messages
    "brand-success": "#00893E",
    "brand-warning": "#F49C10",
    "brand-danger": "#EE3224",
    "brand-info": "#0079C2",

    // Alerts
    "brand-success-alert": "#00893E",
    "brand-warning-alert": "#F49C10",
    "brand-danger-alert": "#EE3224",
    "brand-info-alert": "#0079C2",

    // Alert Borders
    "brand-success-alert-border": "#D5F0CE",
    "brand-warning-alert-border": "#FDECD0",
    "brand-danger-alert-border": "#F9CED2",
    "brand-info-alert-border": "#CEEAF9",

    // Checkbox Count
    "brand-checkbox-count": "#909090",

    // Lighten & Darken
    "brand-primary-lighten": "#188BCC",
    "brand-primary-darken": darken(0.05, brandPrimaryColor),

    "brand-secondary-lighten": lighten(0.05, brandSecondaryColor),
    "brand-secondary-darken": darken(0.05, brandSecondaryColor),

    "brand-tertiary-lighten": lighten(0.05, brandTertiaryColor),
    "brand-tertiary-darken": darken(0.05, brandTertiaryColor),

    "brand-quaternary-lighten": lighten(0.05, brandQuaternaryColor),
    "brand-quaternary-darken": darken(0.05, brandQuaternaryColor),

    "brand-quinary-lighten": lighten(0.05, brandQuinaryColor),
    "brand-quinary-darken": darken(0.05, brandQuinaryColor),

    "brand-black-lighten": lighten(0.05, brandBlackColor),
    "brand-black-darken": darken(0.05, brandBlackColor),

    "brand-grey-lighten": lighten(0.05, brandGreyColor),
    "brand-grey-darken": darken(0.05, brandGreyColor),

    "brand-white-lighten": lighten(0.05, brandWhiteColor),
    "brand-white-darken": darken(0.05, brandWhiteColor),
};

const fonts = {
    heading: ["interstate", "sans-serif"],
    body: ["interstate", "sans-serif"],
};

module.exports = { colors, fonts };
